<template>
  <div class="ms-container">
    <row :gutter="16">
      <i-col span="8">
        <contragent-info
          ref="commonInfo"
          @update="updateChildren('commonInfo')"
        />
        <contract-documents style="margin-top: 16px" />
      </i-col>
      <i-col span="16">
        <contragent-stats
          ref="stats"
          @update="updateChildren('stats')"
          :style="hasAmendments ? 'margin-top: 19px' : 'margin-top: 0px;'"
        />
        <contract-roadmap
          ref="roadmap"
          @update="updateChildren('roadmap')"
          style="margin-top: 16px"
        />
      </i-col>
    </row>
  </div>
</template>

<script>
import ContragentInfo from '@/components/contragent/overview/contragent-info'
import ContragentStats from '@/components/contragent/overview/contragent-stats'
import ContractRoadmap from '@/components/contract/overview/contract-roadmap'
import ContractDocuments from '@/components/contract/overview/contract-documents'

export default {
  components: {
    ContragentInfo,
    ContragentStats,
    ContractRoadmap,
    ContractDocuments
  },
  watch: {
    '$route.params.id': function () {
      this.changeContract()
    }
  },
  computed: {
    hasAmendments () {
      const { current } = this.$store.state.contracts

      if (!current) return false

      return current.amendments && !!current.amendments.length
    }
  },
  methods: {
    updateChildren (source) {
      const children = ['commonInfo', 'stats', 'roadmap']

      children
        .filter((ch) => ch !== source)
        .forEach((name) => this.$refs[name].getData())
    },
    changeContract () {
      const children = ['commonInfo', 'subInfo', 'stats', 'roadmap']
      children.forEach((name) => this.$refs[name].getData())
    }
  }
}
</script>

<style>
</style>
